// Definitions taken from API
import { AssetsPermissions } from './assetsPermissions.enum';
import { ElearningPermissions } from './elearningPermissions.enum';
import { QuizPermissions } from './quizPermissions.enum';
import { ReviewerPermissions } from './reviewerPermissions.enum';
import { SlidePermissions } from './slidePermissions.enum';
import { CourseLibraryPermissions } from './courseLibraryPermissions.enum';
import { AdminPermissions } from './adminPermissions.enum';
import { AllAccessPermission } from './allAccessPermission.enum';

export const ElaPermissions = {
  ...AssetsPermissions,
  ...ElearningPermissions,
  ...CourseLibraryPermissions,
  ...QuizPermissions,
  ...ReviewerPermissions,
  ...SlidePermissions,
  ...AdminPermissions,
  ...AllAccessPermission,
};

export type ElaPermissions =
  | AssetsPermissions
  | ElearningPermissions
  | CourseLibraryPermissions
  | QuizPermissions
  | ReviewerPermissions
  | SlidePermissions
  | AdminPermissions
  | AllAccessPermission;

export default ElaPermissions;
